import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { ProjectContext } from "./website/context/ProjectContext";
import { useNavigate } from "react-router-dom";
import ProjectOverview from "./website/project_details/ProjectOverview";
import ProjectLocation from "./website/project_details/ProjectLocation";
import ImpactProgress from "./website/project_details/ImpactProgress";
import FinancialDetails from "./website/project_details/FinancialDetails";
import ImplementationDetails from "./website/project_details/ImplementationDetails";
import QuickActions from "./website/project_details/QuickActions";
import ProjectHeader from "./website/project_details/ProjectHeader";
import DocumentsReports from "./website/project_details/DocumentsReports";

const ProjectDetails = () => {
  const { id } = useParams(); 
  const { getProjectDetails } = useContext(ProjectContext);
const navigate = useNavigate();
  useEffect(() => {
    if (id) {
      getProjectDetails(id); 
    }
  }, [id]);

  return (
    <>
    <ProjectHeader onBack={() => navigate("/projects")} />

      <div className="container py-4">
        <div className="row g-4">
          <div className="col-lg-8 col-md-12">
            <ProjectOverview />
            <ProjectLocation />
            <ImpactProgress />
          </div>

          <div className="col-lg-4 col-md-12">
            <FinancialDetails />
            <ImplementationDetails />
            {/* <QuickActions /> */}
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12">
            <DocumentsReports />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectDetails;
